import React, { useState } from "react";
import { Container, Paper, Checkbox, Button } from "@mantine/core";
import axios from "axios";
import { useLocation } from "react-router-dom";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const DataDonationConsentForm = () => {
  const [consentGiven, setConsentGiven] = useState(false);
  const query = useQuery();
  const currentQueryString = useLocation().search;
  const PROLIFIC_PID = query.get("PROLIFIC_PID");
  const STUDY_ID = query.get("STUDY_ID");
  const SESSION_ID = query.get("SESSION_ID");
  const apiUrl = process.env.REACT_APP_API_URL;
  
  const createTracker = async () => {
     try {
       const response = await axios.post(`${apiUrl}/createTracker`, {
         prolific_pid: PROLIFIC_PID,
         study_id: STUDY_ID,
       });

       console.log("Tracker created:", response.data);
     } catch (error) {
       console.error("There was an error creating the tracker:", error);
     }
   };

  console.log(PROLIFIC_PID,STUDY_ID,SESSION_ID)
  const handleConsentChange = () => {
    setConsentGiven(!consentGiven);
  };

  const handleSubmit = async () => {
   
    if (consentGiven) {
       
      // Submit the form or perform any other action here
      // For demonstration purposes, we're just logging a message to the console
      await createTracker();
      console.log("current qurey in data form",currentQueryString)
      window.location.href = `/create-uuid${currentQueryString}`;
    } else {
      // Show a message indicating that consent is required
      alert("Please provide your consent to donate your data.");
    }
  };

  return (
    <Container size="md">
      <Paper padding="lg">
        <h1 style={{ textAlign: "center" }}>Data Donation Consent Form</h1>
        <p>
          Thank you for considering participating in our research project. We
          are conducting a study with the goal of gaining valuable insights into
          user behavior and online patterns. As part of this research, we kindly
          request your voluntary participation to donate your YouTube watch
          history and Chrome browsing history data through Google Takeout.
        </p>

        <h3>Study Purpose</h3>
        <p>
          The purpose of this research project is to analyze trends,
          preferences, and user interactions within YouTube and Chrome
          platforms. By examining this data, we aim to better understand how
          users engage with online content, the types of videos they find most
          appealing, and the browsing habits that drive their online
          experiences. The insights gained from this research will be valuable
          in improving content creation, user interface design, and personalized
          recommendations, ultimately leading to a more enriching online
          environment for all users.
        </p>

        <h3>Data Collection and Anonymization</h3>
        <p>
          If you choose to participate, you will be asked to provide your
          YouTube watch history and Chrome browsing history data through Google
          Takeout. We want to assure you that your privacy is of the utmost
          importance to us. To protect your confidentiality, we will anonymize
          your data before analysis. This means that any information that could
          be used to identify you, such as your name, email address, or any
          other personally identifiable information, will be removed from the
          dataset.
        </p>

        <h3>Data Usage and Storage</h3>
        <p>
          The data you provide will only be used for research purposes within
          the scope of this project. It will be securely stored in a protected
          environment accessible only to authorized researchers. We will take
          all necessary precautions to ensure the security and integrity of your
          data during the storage and analysis processes.
        </p>

        <h3>Voluntary Participation and Withdrawal</h3>
        <p>
          Your participation in this data donation process is entirely
          voluntary. If you choose to participate, you may withdraw your consent
          and discontinue participation at any time without any negative
          consequences. If you decide to withdraw, any data collected up to that
          point will be retained, but no further data will be collected from
          you.
        </p>

        <h3>Data Sharing and Transparency</h3>
        <p>
          It is essential to understand that the anonymized data collected from
          you may be shared with other researchers, institutions, or
          organizations for scientific and academic purposes. However, all data
          sharing will be done in a manner that preserves your anonymity.
          Additionally, the results of this research may be published in
          scientific journals or presented at academic conferences. However, any
          published results will only include aggregated data and will not
          include any information that could identify individual participants.
        </p>

        <h3>Contact Information</h3>
        <p>
          If you have any questions or concerns about this research or the data
          donation process, you can contact the research team at [contact
          email/phone number]. We are here to provide any additional information
          you may need and address any concerns you may have.
        </p>

        <h3>Conclusion</h3>
        <p>
          By donating your YouTube watch history and Chrome browsing history
          data, you contribute to the advancement of knowledge and the
          enhancement of user experiences in the digital realm. We greatly
          appreciate your time and consideration in this matter. Your support
          and collaboration are integral to the success of this research
          project, and we are sincerely grateful for your willingness to
          contribute.
        </p>

        <Checkbox
          checked={consentGiven}
          onChange={handleConsentChange}
          label="I voluntarily agree to donate my YouTube watch history and Chrome browsing history data for research purposes."
        />
        <Button onClick={handleSubmit} style={{ marginTop: "20px" }} type="button">
          Submit
        </Button>
      </Paper>
    </Container>
  );
};

export default DataDonationConsentForm;
